import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import BasketComponent from './js/basket.component';

ComponentsFactory.getInstance().define('basket', BasketComponent);
